export interface IMCC {
  mccCode: string
  mccEnName: string
  mccPaymentBrandMap?: IMCCPaymentBrandMap
}

export interface IMCCPaymentBrandMap {
  ALP?: IMCC
  MCC?: IMCC
  UPI?: IMCC
  VIS?: IMCC
  WXP?: IMCC
}

export interface IMCCQuery {
  paymentBrand: MCCType
  limit: number
  page: number
  keyword?: string
}

export enum MCCType {
  Standard = 'standard',
  Alipay = 'ALP',
  WeChat = 'WXP',
  WeChatHK = 'WHK',
  Grab = 'GRB',
  TrueMoney = 'TRU',
  NTT = 'DOT',
  TIS = 'TIS',
  UPI = 'UPI',
  Visa = 'VIS',
  MasterCard = 'MCC',
  FPS = 'FPS',
  // emptyæ¯ä¸ºäºå¼å®¹MCCTypeä¸ºç©ºçæåµ
  empty = ''
}
